 
import React, { useEffect, useState } from "react";
import classes from "../css/LoginPage.module.css";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import { baseUrl, loginApi } from "../api/api";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../components/Layout";
import Drawer from "../components/Drawer";
import Lottie from "lottie-react";
import footballAnimation from "../animations/logo.json";
import { setUser } from "../slices/userSlice";

import SHA256 from "crypto-js/sha256";


const LoginPage = () => {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.userSlice);
  const { lang } = useSelector((state) => state.langSlice);

  const location = useLocation();
  const { status, path, message } = location.state || {
    status: null,
    path: null,
  };

function encrypt(value, length = 8) {
  const hash = SHA256(String(value)).toString(); // hex
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

  let result = "";
  for (let i = 0; i < length; i++) {
    const hexPair = hash.substr(i * 2, 2);
    const num = parseInt(hexPair, 16);
    result += letters[num % letters.length];
  }

  return result;
}
  

  useEffect(() => {
    const savedMsisdn = localStorage.getItem("msisdn");

    if (savedMsisdn) {
      setLoading(true)
      setMobile(savedMsisdn);
      setPassword(savedMsisdn);
      autoLogin(savedMsisdn);
    }

    if (status === "redirect") {
      toast.info(message);
    }
  }, []);

  const autoLogin = async (msisdn) => {


    const number = await encrypt(msisdn);
console.log(number.slice(0,7))

    try {
      setLoading(true);
      const data = { number: number.slice(0,7), password: msisdn };
      const res = await axios.post(`${baseUrl}${loginApi}`, data);

      dispatch(setUser(res?.data));
      toast.success(
        lang === "english"
          ? "Logged In Automatically!"
          : lang === "spanish"
          ? "¡Inicio de sesión automático!"
          : lang === "french"
          ? "Connexion automatique réussie!"
          : lang === "arabic"
          ? "تم تسجيل الدخول تلقائيًا!"
          : "Logged In Automatically!"
      );

      if (status === "redirect") {
        // navigate(`${path}`);
        navigate("/profile");
      } else {
        navigate("/profile");
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message ||
        error?.data?.message ||
        error?.message ||
        "Login Failed"
      );
      console.log(error, "autoLogin error");
    } finally {
      setLoading(false);
    }
  };

  const navigateHandler = () => {
    if (status === "redirect") {
      navigate("/signup", {
        state: {
          status: "redirect",
          path: `${path}`,
          message: message,
        },
      });
    } else {
      navigate("/signup");
    }
  };

  return (
    <Layout active={7}>
      <Drawer active={7} />
      {loading ? <Loader />: 
      <div className={classes.container}>
        <div className={classes.sub_container}>
          <div className={classes.image_main_container}>
            <div className={classes.image_container}>
              <Lottie
                animationData={footballAnimation}
                loop={true}
                autoPlay={true}
              />
            </div>
          </div>

          <div className={classes.login_form}>
            <div className={classes.login_text}>
              <h2 className={classes.title}>Kick n Winn</h2>
            </div>

            <form className={classes.form} onSubmit={(e) => e.preventDefault()}>
              <InputText
                className="p-inputtext-lg"
                value={mobile}
                keyfilter="int"
                onChange={(e) => setMobile(e.target.value)}
                placeholder={
                  lang === "english"
                    ? "Number"
                    : lang === "spanish"
                    ? "Número"
                    : lang === "french"
                    ? "Nombre"
                    : lang === "arabic"
                    ? "رقم"
                    : "Number"
                }
                style={{ width: "100%" }}
              />
              <InputText
                className="p-inputtext-lg"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={
                  lang === "english"
                    ? "Password"
                    : lang === "spanish"
                    ? "Contraseña"
                    : lang === "french"
                    ? "Mot de passe"
                    : lang === "arabic"
                    ? "كلمة المرور"
                    : "Password"
                }
                type="password"
                style={{ width: "100%" }}
              />
              <button type="submit" className={classes.login_btn}>
                {lang === "english"
                  ? "Login"
                  : lang === "spanish"
                  ? "Acceso"
                  : lang === "french"
                  ? "Se connecter"
                  : lang === "arabic"
                  ? "تسجيل الدخول"
                  : "Login"}
              </button>
              <div onClick={navigateHandler} className={classes.link}>
                {lang === "english"
                  ? "If you don't have an account , Sign Up"
                  : lang === "spanish"
                  ? "Si no tienes una cuenta, Regístrate"
                  : lang === "french"
                  ? "Si vous n'avez pas de compte, inscrivez-vous"
                  : lang === "arabic"
                  ? "إذا لم يكن لديك حساب، قم بالتسجيل"
                  : "If you don't have an account , Sign Up"}
              </div>
            </form>
          </div>
        </div>
      </div>
      }
      
    </Layout>
  );
};

export default LoginPage;


